import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle2, Clock, XCircle, Loader2 } from 'lucide-react';

export default function PrenotaConferma() {
  const { token } = useParams();
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get(`/api/public/booking/conferma/${token}`)
      .then(r => setResult(r.data))
      .catch(e => setError(e.response?.data?.detail || 'Link non valido o scaduto'));
  }, [token]);

  const box = (icon, title, text, testid) => (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-8 max-w-md text-center" data-testid={testid}>
        {icon}
        <h1 className="text-xl font-bold text-slate-900 mb-2">{title}</h1>
        <p className="text-sm text-slate-500">{text}</p>
        <p className="text-xs text-slate-400 mt-4">F.lli Schilirò Assicurazioni — 095 7938069</p>
      </div>
    </div>
  );

  if (error) return box(
    <div className="w-16 h-16 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-4"><XCircle size={28} className="text-red-500" /></div>,
    'Link non valido', error, 'conferma-error');

  if (!result) return box(
    <div className="w-16 h-16 rounded-full bg-slate-50 flex items-center justify-center mx-auto mb-4"><Loader2 size={28} className="text-slate-400 animate-spin" /></div>,
    'Verifica in corso...', 'Attendere qualche istante.', 'conferma-loading');

  if (result.stato === 'confermato') return box(
    <div className="w-16 h-16 rounded-full bg-emerald-50 flex items-center justify-center mx-auto mb-4"><CheckCircle2 size={28} className="text-emerald-600" /></div>,
    'Appuntamento confermato!',
    `Ti aspettiamo il ${result.data} alle ${result.ora}. Riceverai un promemoria prima dell'appuntamento.`,
    'conferma-ok');

  if (result.stato === 'in_attesa_approvazione') return box(
    <div className="w-16 h-16 rounded-full bg-amber-50 flex items-center justify-center mx-auto mb-4"><Clock size={28} className="text-amber-500" /></div>,
    'Email confermata — in attesa di approvazione',
    `La tua richiesta per il ${result.data} alle ${result.ora} è stata ricevuta. Essendo un nuovo contatto, il nostro team la confermerà a breve: riceverai una email di conferma definitiva.`,
    'conferma-attesa');

  return box(
    <div className="w-16 h-16 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-4"><XCircle size={28} className="text-red-500" /></div>,
    'Slot non più disponibile',
    `Purtroppo l'orario del ${result.data} alle ${result.ora} è stato appena occupato. Torna alla pagina di prenotazione e scegli un altro orario.`,
    'conferma-occupato');
}
